<template>
<div class="chapter">
<div class="inner_page">
<p class="p1"><span class="t1">Copyright</span></p>
<p class="p1"><span class="t2">Published by</span></p>
<p class="p1"><span class="t2">Dreamspinner Press</span></p>
<p class="p1"><span class="t2">382 NE 191st Street #88329</span></p>
<p class="p1"><span class="t2">Miami, FL 33179-3899, USA</span></p>
<p class="p1"><a href="http://www.dreamspinnerpress.com/" target="_blank"><span class="t3">http://www.dreamspinnerpress.com/</span></a></p>
<p class="p1"><span class="t2"> </span></p>
<p class="p1"><span class="t2">This is a work of fiction. Names, characters, places, and incidents either are the product of the author’s imagination or are used fictitiously, and any resemblance to actual persons, living or dead, business establishments, events, or locales is entirely coincidental.</span></p>
<p class="p1"><span class="t2"> </span></p>
<p class="p1"><span class="t2">The Zero Knot</span></p>
<p class="p1"><span class="t2">Copyright © 2011 by K.Z. Snow</span></p>
<p class="p1"><span class="t2"> </span></p>
<p class="p1"><span class="t2">Cover Art by Anne Cain    annecain.art@gmail.com</span></p>
<p class="p1"><span class="t2">Cover Design by Mara McKennen</span></p>
<p class="p1"><span class="t2"> </span></p>
<p class="p1"><span class="t2">All rights reserved. No part of this book may be reproduced or transmitted in any form or by any means, electronic or mechanical, including photocopying, recording, or by any information storage and retrieval system without the written permission of the Publisher, except where permitted by law. To request permission and all other inquiries, contact Dreamspinner Press, 382 NE 191st Street #88329, Miami, FL 33179-3899, USA</span></p>
<p class="p1"><a href="http://www.dreamspinnerpress.com/" target="_blank"><span class="t3">http://www.dreamspinnerpress.com/</span></a></p>
<p class="p1"><span class="t2"> </span></p>
<p class="p1"><span class="t2">ISBN: 978-1-61372-204-6</span></p>
<p class="p1"><span class="t2"> </span></p>
<p class="p1"><span class="t2">Printed in the United States of America</span></p>
<p class="p1"><span class="t2">First Edition</span></p>
<p class="p1"><span class="t2">October 2011</span></p>
<p class="p1"><span class="t2"> </span></p>
<p class="p1"><span class="t2">eBook edition available</span></p>
<p class="p1"><span class="t2">eBook ISBN: 978-1-61372-205-3</span></p>
<p> </p>
</div>
</div>
</template>
<script>

export default {
  name: 'chapter',
  data() {
    return {}
    },
      components: {
    }
  }
</script>



// WEBPACK FOOTER //
// 003.vue?735ad464